import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "lc-bsinfo"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  key: 1,
  style: {
    "color": "#c0c4cc"
  }
};
const _hoisted_4 = {
  style: {
    "padding-bottom": "50px"
  }
};
import { ElMessage } from 'element-plus';
import { reactive, ref, getCurrentInstance, provide } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { routeLinksConversion } from '../../../utils/lc_jx_utils/lc_jx.js';
import { prlisttopBt } from '../../../utils/lc_data'; // 获取人员
import { getUsers } from '../../../utils/lc'; // 获取人员
/* 数据 */

export default {
  __name: 'edit',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    let {
      proxy
    } = getCurrentInstance(); // this替代
    let remark = ref('');
    let baseInfo = ref('');
    provide('project_id', route.query.id);
    console.log('项目id', route.query.id);
    // 任务信息列表
    let data = reactive({
      tasktable: [],
      userlist: [],
      xtshow: false,
      projectId: route.query.id,
      ggdyTableData: [],
      // 规格定义表
      //富文本
      height: 300,
      key: '',
      id: '',
      ggdybts: 'edit'
    });
    const btsArry = reactive(JSON.parse(JSON.stringify(prlisttopBt)));
    // 基本信息组件值
    const addBaseInfo = ref();
    const lcButtons = ref();
    /* 初始化获取数据 */
    getUsers({
      page: 1,
      size: 999999,
      nickname: ''
    }).then(res => {
      data.userlist = res.data;
      getPageInfo();
    });
    provide('project_id', route.query.id);
    /* 方法 */
    // function getlistName(id =>{
    //   ret
    // })
    //获取项目详情
    function getPageInfo() {
      if (route.query.id) {
        proxy.$http.showLoading(true).get('project/project/info?id=' + route.query.id).then(res => {
          if (res.errno == 200) {
            baseInfo.value = JSON.parse(JSON.stringify(res.data));
            data.tasktable = res.data.task ? res.data.task : [];
            data.ggdyTableData = [];
            data.ggdyTableData = res.data.skus ? res.data.skus : [];
            remark.value = res.data.remark;
            res.data.skus.forEach((it, index) => {
              res.data.skus[index].index = index + 1;
              res.data.skus[index].links_qd_bom = '';
              res.data.skus[index].links_bz_bom = '';
            });
            let keys = ['id', 'sn', 'image', 'name', 'leader_user_id', 'status', 'issue_time', 'status_text', 'level', 'code', 'bh', 'cate_id', 'plan_start_time', 'plan_end_time', 'start_time', 'end_time', 'product_time', 'online_time', 'brand_ids'];
            keys.forEach(it => {
              addBaseInfo.value.form[it] = res.data[it];
              if (it == 'image') {
                addBaseInfo.value.imageUrl = res.data[it];
              }
              if (it == 'cate_id') {
                let arr = [];
                res.data[it].forEach(it => {
                  arr.push(parseInt(it));
                });
                addBaseInfo.value.form[it] = arr;
              }
              if (it == 'brand_ids') {
                addBaseInfo.value.form[it] = res.data[it] ? res.data[it].split(',').map(Number) : '';
              }
              if (it == 'level') {
                addBaseInfo.value.form[it] = res.data[it] ? parseInt(res.data[it]) : '';
              }
            });
          }
        });
      }
    }
    function formatMulti(id) {
      let it = [];
      if (data.userlist && data.userlist.length > 0 && id) {
        it = data.userlist.filter(i => {
          return i.id == id;
        });
        return it && it.length > 0 ? it[0].nickname : '';
      }
    }
    //富文本编辑器
    function inputContent(value) {
      remark.value = value;
    }
    //按钮组操作
    function btsEmit(value) {
      // 日志
      if (value == 'logbt') {
        router.push({
          path: '/lcProject/log/prlog',
          query: {
            project_id: route.query.id,
            projectName: addBaseInfo.value.form.name
          }
        });
      }
      // 点击保存
      if (value == 'saveProject') {
        saveProject();
      }
      // 继续项目goOnPrijectbt   暂停项目stopProjectbt    结束closeProjectbt
      if (value == 'goOnPrijectbt' || value == 'stopProjectbt' || value == 'closeProjectbt') {
        proxy.$http.showLoading(false).get('project/project/ch_status', {
          id: route.query.id,
          status: value == 'goOnPrijectbt' ? 30 : value == 'stopProjectbt' ? 20 : value == 'closeProjectbt' ? 40 : 0
        }).then(res => {
          if (res.errno == 200) {
            ElMessage({
              type: 'success',
              message: '操作成功'
            });
            getPageInfo();
          } else {
            ElMessage({
              type: 'error',
              message: res.errmsg
            });
          }
        });
      }
      if (value == 'pushdown') {
        if (baseInfo.value.id) {
          data.xtshow = true;
        }
      }
    }
    // 保存
    function saveProject() {
      let editdata = JSON.parse(JSON.stringify(addBaseInfo.value.form));
      if (editdata.name && editdata.cate_id && editdata.brand_ids) {
        editdata.id = baseInfo.value.id;
        editdata.brand_ids = editdata.brand_ids.join(',');
        editdata.cate_id = editdata.cate_id && editdata.cate_id.length > 0 ? editdata.cate_id[editdata.cate_id.length - 1] : '';
        editdata.remark = remark.value;
        editdata.task = JSON.parse(JSON.stringify(data.tasktable));
        editdata.skus = JSON.parse(JSON.stringify(data.ggdyTableData));
        proxy.$http.showLoading(false).post('project/project/edit', editdata).then(res => {
          if (res.errno == 200) {
            ElMessage({
              type: 'success',
              message: '保存成功'
            });
            getPageInfo();
          } else {
            ElMessage({
              type: 'error',
              message: res.errmsg
            });
          }
        });
      } else {
        ElMessage({
          type: 'error',
          message: '请填写必填项！'
        });
      }
    }
    // 获取路由跳转
    function getRouteInfo(rowInfo) {
      let item = JSON.parse(JSON.stringify(rowInfo));
      router.push({
        path: '/lcProject/taskMange/' + routeLinksConversion(item.basetask_id),
        query: {
          id: item.project_id,
          prBasetaskId: item.id
        }
      });
    }
    function handelClose() {
      data.xtshow = false;
    }
    return (_ctx, _cache) => {
      const _component_LcButtons = _resolveComponent("LcButtons");
      const _component_lcBaseInfo = _resolveComponent("lcBaseInfo");
      const _component_vxe_column = _resolveComponent("vxe-column");
      const _component_vxe_option = _resolveComponent("vxe-option");
      const _component_vxe_select = _resolveComponent("vxe-select");
      const _component_vxe_table = _resolveComponent("vxe-table");
      const _component_lcggdytab = _resolveComponent("lcggdytab");
      const _component_lctinymce = _resolveComponent("lctinymce");
      const _component_lcDailogxt = _resolveComponent("lcDailogxt");
      const _component_el_main = _resolveComponent("el-main");
      return _openBlock(), _createBlock(_component_el_main, {
        class: "bg_white wrap_box lcpg"
      }, {
        default: _withCtx(() => [_createVNode(_component_LcButtons, {
          ref_key: "lcButtons",
          ref: lcButtons,
          type: 1,
          onBtsEmit: _cache[0] || (_cache[0] = $event => btsEmit($event)),
          bts: btsArry
        }, null, 8, ["bts"]), _createVNode(_component_lcBaseInfo, {
          ref_key: "addBaseInfo",
          ref: addBaseInfo,
          type: "info"
        }, null, 512), _createElementVNode("div", _hoisted_1, [_cache[4] || (_cache[4] = _createElementVNode("div", {
          class: "lc_title"
        }, "任务信息列表", -1)), _createVNode(_component_vxe_table, {
          resizable: "",
          id: "tasktbale",
          "scroll-x": {
            enabled: false
          },
          "row-config": {
            isHover: true
          },
          "scroll-y": {
            enabled: false
          },
          keepSource: "",
          "custom-config": {
            storage: true
          },
          border: "",
          "show-overflow": "",
          data: _unref(data).tasktable,
          "edit-config": {
            trigger: 'click',
            mode: 'cell',
            showStatus: true
          },
          "column-config": {
            resizable: true
          },
          class: "ggdycss",
          "max-height": "500"
        }, {
          default: _withCtx(() => [_createVNode(_component_vxe_column, {
            field: "name",
            title: "任务名称",
            width: "200",
            align: "left"
          }, {
            default: _withCtx(({
              row
            }) => [row.is_push == '1' ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: $event => getRouteInfo(row),
              style: {
                "color": "#409EFF",
                "cursor": "pointer"
              }
            }, _toDisplayString(row.name), 9, _hoisted_2)) : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(row.name), 1))]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            field: "leader_user_name",
            title: "任务负责人",
            width: "145",
            align: "left"
          }), _createVNode(_component_vxe_column, {
            field: "reviewer_user_id",
            title: "任务审核人",
            width: "200",
            align: "left",
            "edit-render": {
              autofocus: '.vxe-input--inner'
            }
          }, {
            default: _withCtx(({
              row
            }) => [_createElementVNode("span", null, _toDisplayString(formatMulti(row.reviewer_user_id)), 1)]),
            edit: _withCtx(({
              row
            }) => [_createVNode(_component_vxe_select, {
              modelValue: row.reviewer_user_id,
              "onUpdate:modelValue": $event => row.reviewer_user_id = $event,
              transfer: "",
              placeholder: "请选择"
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).userlist, item => {
                return _openBlock(), _createBlock(_component_vxe_option, {
                  key: item.id,
                  label: item.nickname,
                  value: item.id
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])]),
            _: 1
          }), _createVNode(_component_vxe_column, {
            field: "committed_step_text",
            title: "是否关键步骤",
            width: "145",
            align: "left"
          }), _createVNode(_component_vxe_column, {
            field: "examine_status_text",
            title: "任务审核状态",
            width: "145",
            align: "left"
          }), _createVNode(_component_vxe_column, {
            field: "plan_start_time_text",
            title: "预计开始时间",
            width: "145",
            align: "left"
          }), _createVNode(_component_vxe_column, {
            field: "plan_end_time_text",
            title: "预计结束时间",
            width: "145",
            align: "left"
          }), _createVNode(_component_vxe_column, {
            field: "start_time_text",
            title: "开始时间",
            width: "145",
            align: "left"
          }), _createVNode(_component_vxe_column, {
            field: "end_time_text",
            title: "结束时间",
            width: "145",
            align: "left"
          }), _createVNode(_component_vxe_column, {
            field: "msg",
            title: "驳回原因",
            width: "250",
            align: "left"
          })]),
          _: 1
        }, 8, ["data"]), _cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "lc_title lc_ttop lc_add_ggdyb"
        }, "规格定义表", -1)), _createVNode(_component_lcggdytab, {
          ggdyTableData: _unref(data).ggdyTableData,
          "onUpdate:ggdyTableData": _cache[1] || (_cache[1] = $event => _unref(data).ggdyTableData = $event),
          ggdybts: _unref(data).ggdybts,
          "onUpdate:ggdybts": _cache[2] || (_cache[2] = $event => _unref(data).ggdybts = $event),
          proojectId: _unref(baseInfo).id,
          onGetPageInfo: getPageInfo,
          deppgetPageInfo: getPageInfo,
          skufield: _unref(baseInfo).sku_field
        }, null, 8, ["ggdyTableData", "ggdybts", "proojectId", "skufield"]), _cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "lc_ttop lc_bzt"
        }, "备注", -1)), _createElementVNode("div", _hoisted_4, [(_openBlock(), _createBlock(_component_lctinymce, {
          ref: "editor",
          height: _unref(data).height,
          "cur-value": _unref(remark),
          onInput: inputContent,
          id: _unref(data).id,
          key: _unref(data).key
        }, null, 8, ["height", "cur-value", "id"]))])]), _unref(data).xtshow ? (_openBlock(), _createBlock(_component_lcDailogxt, {
          key: 0,
          onHandelClose: handelClose,
          xtshow: _unref(data).xtshow,
          "onUpdate:xtshow": _cache[3] || (_cache[3] = $event => _unref(data).xtshow = $event),
          projectId: _unref(data).projectId,
          onGetinit: getPageInfo
        }, null, 8, ["xtshow", "projectId"])) : _createCommentVNode("", true)]),
        _: 1
      });
    };
  }
};